import styled from 'styled-components'

export default styled.div`
  position: fixed;
  left: -10000px;
  top: -10000px;
  width: 800px;
  height: 600px;
  pointer-events: none;
`
